import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class RoleService extends BaseService{
	constructor() {
		super('/Role');
	}

	//private _resourceName = '';


	//jak tady nadefinovat metodu      GetRoleByUserIdList(uint userId)	 ???
	//public GetRoleDTO(id: number) {
	//	return this.(`${this._resourceName}/${id}`);
	//}

	public getAllByFilter(filter: RoleFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class RoleFilter extends BaseFilter{
	constructor(idUser?: number | null, idRight?: number | null, idTenant?: number | null) {
		super();
		this._idUser = idUser;
		this._idRight = idRight;
		this._idTenant = idTenant;
	}

	private _idUser?: number | null;
	private _idRight?: number | null;
	private _idTenant?: number | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idUser != null ? { IdUser: this._idUser } : {}),
			(this._idRight != null ? { IdRight: this._idRight } : {}),
			(this._idTenant != null ? { IdTenant: this._idTenant } : {})

		);

		return data;
	};
}